import { render, staticRenderFns } from "./TheLoader.vue?vue&type=template&id=4a0830d5&scoped=true"
import script from "./TheLoader.vue?vue&type=script&lang=js"
export * from "./TheLoader.vue?vue&type=script&lang=js"
import style0 from "./TheLoader.vue?vue&type=style&index=0&id=4a0830d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0830d5",
  null
  
)

export default component.exports